import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { TranslocoModule } from '@jsverse/transloco';

import { CapitalizePipe } from '@hmax-order/frontend/utils';
import { ValidateFieldsService } from '../validate-fields.service';

@Component({
  selector: 'hmax-input-slide-toggle',
  standalone: true,
  templateUrl: './input-slide-toggle.component.html',
  styleUrls: ['./input-slide-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CapitalizePipe, MatFormFieldModule, MatSlideToggleModule, ReactiveFormsModule, TranslocoModule],
})
export class InputSlideToggleComponent implements OnInit {
  @ViewChild('inputRef', { static: false, read: ElementRef }) input!: ElementRef;

  inputId!: string;

  @Input() inputIdentifier = '';
  @Input() label!: string;
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() disabled = false;
  @Input() labelPosition: 'before' | 'after' = 'after';

  get formControl(): AbstractControl {
    return this.formGroup.controls[this.controlName];
  }

  public validateField = inject(ValidateFieldsService);

  ngOnInit(): void {
    this.inputId = this.inputIdentifier;
    // Carregar controlName com o label se não houver controlName definido
    this.controlName = this.controlName ?? this.label;
  }
}
